export default __webpack_public_path__ + "static/media/checked.30c290b4.png";